<template>
  <div v-if="order">
    <a-row type="flex" justify="center" style="paddingBottom:55px">
      <a-col span="22">
        <a-steps :current="current" :status="status">
          <a-step
              v-for="item in tabs"
              :key="item.title"
              :title="item.title"
              :description="item.time"
          ></a-step>
        </a-steps>
      </a-col>
    </a-row>
    <a-alert v-if="showAlert"
             message=""
             banner
             closable
    >
      <p slot="description" style="margin-bottom:0;">温馨提示：系统检测到该职位已有猎头推荐同名候选人，疑似重复推荐！<span @click="goDetail"
                                                                                           style="color:blue;cursor: pointer;">点此查看详情 </span>
      </p>
    </a-alert>
    <a-divider></a-divider>
    <a-list itemLayout="vertical">
      <a-list-item-meta>
        <span slot="description">订单编号：{{ order.order_no }}</span>
        <span slot="description"
              style="margin-left: 20px">推荐类型：{{ order.source == "columbus_mini_app" ? '候选人投递' : '猎头推荐' }}</span>
        <b style="font-size:16px;color:#35B5FE" slot="title"
        >订单状态：{{ order.status_text }}</b
        >
      </a-list-item-meta>
      <a-list-item style="padding-left:20px;">
        <h4>申请职位：{{ job.name }}</h4>
        <h4>申请公司：{{ job.company.name }}</h4>
        <!-- <h4>申请时间：{{ order.created_at }}</h4> -->
        <div
            slot="actions"
            v-if="
            status === 'process' &&
              order.ie_user_id == $store.state.user.uid &&
              isGranted('post_manager.post_process_list.btn_list_audit')
          "
        >
          <template v-if="order.status == 'CREATED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click.stop="nextStep('审核通过', order)"
            >审核通过
            </a-button
            >
            <a-button
                style="margin-right:20px"
                @click.stop="stopStep('审核不通过', order)"
            >审核不通过
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button>
            <a-button type="link">附件简历</a-button>-->
          </template>
          <template v-if="order.status == 'DELIVER'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="$refs.checkDeliveryModal.show(order)"
            >通过并推荐
            </a-button
            >
            <a-button
                style="margin-right:20px"
                @click.stop="stopStep('审核不通过', order)"
            >审核不通过
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button>
            <a-button type="link">附件简历</a-button>-->
          </template>
          <template v-if="order.status == 'AUDIT_PASSED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="nextStep('推荐通过', order)"
            >推荐通过
            </a-button
            >
            <a-button
                style="margin-right:20px"
                @click="stopStep('推荐不通过', order)"
            >推荐不通过
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button> -->
            <!-- <a-button type="link">附件简历</a-button> -->
          </template>
          <template v-if="order.status == 'SUBMIT_PASSED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="$refs.arrangeInterviewModal.show(order)"
            >安排面试
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button> -->
            <!-- <a-button type="link">附件简历</a-button> -->
            <a-button type="link" @click="stopStep('关闭订单', order)"
            >关闭订单
            </a-button
            >
          </template>
          <template v-if="order.status == 'INTERVIEW'">
            <span v-if="order.interviews[0].status === 'PROCESS'">
              <a-button
                  type="primary"
                  style="margin-right:20px"
                  @click="$refs.checkInterviewModal.show(order)"
              >标记面试结果</a-button
              >
              <a-button
                  style="margin-right:20px"
                  @click="$refs.cancelInterviewModal.show(order)"
              >取消面试</a-button
              >
            </span>
            <span v-else>
              <a-button
                  type="primary"
                  style="margin-right:20px"
                  @click="$refs.arrangeInterviewModal.show(order)"
              >安排下一轮面试</a-button
              >
              <a-button
                  type="primary"
                  style="margin-right:20px"
                  @click="$refs.offerModal.show(order)"
              >发送offer</a-button
              >
            </span>
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)">软性点评</a-button> -->
            <!-- <a-button type="link">附件简历</a-button> -->
            <a-button
                type="link"
                v-if="
                order.interviews.length === 1 &&
                  order.interviews[0].status === 'PROCESS'
              "
                @click="stopStep('关闭订单', order)"
            >关闭订单
            </a-button
            >
          </template>
          <template v-if="order.status == 'OFFERED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="nextStep('已入职', order)"
            >已入职
            </a-button
            >
            <a-button
                style="margin-right:20px"
                @click="stopStep('未入职', order)"
            >未入职
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)"
              >软性点评</a-button
            >
            <a-button type="link">附件简历</a-button>-->
          </template>
          <template v-if="order.status == 'ENTERED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="nextStep('已过保', order)"
            >已过保
            </a-button
            >
            <a-button
                style="margin-right:20px"
                @click="stopStep('未过保', order)"
            >未过保
            </a-button
            >
            <a-button
                type="link"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)"
              >软性点评</a-button
            >
            <a-button type="link">附件简历</a-button>-->
          </template>
          <template v-if="order.status == 'COMPLETED'">
            <a-button
                type="primary"
                style="margin-right:20px"
                @click="$refs.addCommunicationModal.show(order)"
            >沟通记录
            </a-button
            >
            <!-- <a-button type="link" @click="$refs.commentModal.show(order)"
              >软性点评</a-button
            >
            <a-button type="link">附件简历</a-button>-->
          </template>
        </div>
      </a-list-item>
    </a-list>
    <div class="order-info">
      <div
          class="btn"
          @click="viewMoreInfo = !viewMoreInfo"
          v-if="order.timelines.length > 1"
      >
        <span v-show="!viewMoreInfo">
          展开
          <a-icon type="down"></a-icon>
        </span>
        <span v-show="viewMoreInfo">
          收起
          <a-icon type="up"></a-icon>
        </span>
      </div>
      <a-row type="flex" justify="start">
        <template v-for="(item, index) in order.timelines">
          <a-col :key="item.id" span="24" v-show="index === 0 || viewMoreInfo">
            <p :style="{ paddingLeft: index > 0 ? '30px' : '0' }">
              <a-icon
                  v-if="index == 0"
                  type="bell"
                  style="margin-right:10px;"
              />
              {{
                `${item.user_name}&nbsp;&nbsp;&nbsp;&nbsp;${item.created_at}&nbsp;&nbsp;&nbsp;&nbsp;${item.post_status_name}`
              }}
            </p>
            <div class="reason" v-if="item.elimination_item && item.elimination_item.body">
              <p>原因：{{ item.elimination_item.body && item.elimination_item.body.reason_text }}</p>
              <p style="padding-left:40px">{{ item.elimination_item.body && item.elimination_item.body.reason }}</p>
              <!-- <div class="reason" v-if="item.elimination_reason">
                {{ handleElimination(item.elimination_reason) }}
                <p>{{ `原因：${item.elimination_reason.other_reasons}` }}</p>
                <p style="padding-left:40px">
                  {{ `${item.elimination_reason.reasons.join("，")}` }}
                </p>
                <p
                  style="padding-left:40px"
                  v-if="item.elimination_reason.expected_monthly_salary > 0"
                >
                  {{
                    `期待月薪：${item.elimination_reason.expected_monthly_salary}k/月`
                  }}
                </p> -->
            </div>
          </a-col>
        </template>
      </a-row>
    </div>
    <a-tabs :defaultActiveKey="communicate">
      <a-tab-pane tab="推荐信息" key="0">
        <recommand
            :source="order"
            @view="$refs.preview.show(order.report.attachment)"
        ></recommand>
      </a-tab-pane>
      <a-tab-pane tab="职位信息" key="1">
        <job :source="job"></job>
      </a-tab-pane>
      <a-tab-pane tab="公司信息" key="2">
        <company :company="job.company"></company>
      </a-tab-pane>
      <a-tab-pane v-if="order.source!='columbus_mini_app'" tab="猎头信息" key="3">
        <hunter :hunter="hunter"></hunter>
      </a-tab-pane>
      <a-tab-pane tab="面试信息" key="4">
        <interview :source="order"></interview>
      </a-tab-pane>
      <a-tab-pane tab="沟通与点评" key="5">
        <contact
            ref="contact"
            :resume="order.resume"
            :id="order.ie_user_id"
            @addSoft="$refs.commentModal.show(order)"
            @addCommunication="$refs.addCommunicationModal.show(order)"
            @addAttachment = '$refs.addAttachmentModal.show(order)'
        ></contact>
      </a-tab-pane>
      <a-tab-pane v-if="hunter_state==3" tab="做单求助" key="6">
        <a-row type="flex" justify="space-between" style="margin-bottom:15px">
          <a-col>
            <a-row type="flex" align="middle" :gutter="15">
              <a-col>
                <span style="height:25px;border-left:3px solid #35B5FE;"></span>
              </a-col>
              <a-col>
                <b>求助记录</b>
              </a-col>
            </a-row>
          </a-col>
        </a-row>
        <a-timeline>
          <a-timeline-item v-for="(item,index) in hunter_help_list" :key="index">
            <a-row>
              <a-col :span="5">
                {{ item.updated_at }}
              </a-col>
              <a-col :span="19">
                <span :style="{
              color:item.ask_help_status==1?'rgb(245, 154, 35)':
                  item.ask_help_status==2?'rgb(2, 167, 240)':
                      item.ask_help_status==3?'rgb(112, 182, 3)':
                          item.ask_help_status==4?'rgb(51, 51, 51)':
                              item.ask_help_status==5?'rgb(217, 0, 27)':'rgb(51, 51, 51)'
            }">{{
                    item.ask_help_status == 1 ? '待受理' :
                        item.ask_help_status == 2 ? '已受理' :
                            item.ask_help_status == 3 ? '已完成' :
                                item.ask_help_status == 4 ? '已撤回' :
                                    item.ask_help_status == 5 ? '已拒绝' : '已拒绝'
                  }}</span>
              </a-col>
            </a-row>
            <a-row>
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>{{
                    item.ask_help_status == 1 ? '提交时间：' + item.updated_at :
                        item.ask_help_status == 2 ? '受理时间：' + item.updated_at :
                            item.ask_help_status == 3 ? '完成时间：' + item.updated_at :
                                item.ask_help_status == 4 ? '撤回时间：' + item.updated_at :
                                    item.ask_help_status == 5 ? '拒绝时间：' + item.updated_at : item.updated_at
                  }}</p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 1 && item.ask_type_text && item.ask_type_text.length>0">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  求助类型：
                  <span v-for="(itemask,indexask) in item.ask_type_text" :key="indexask">{{
                      itemask
                    }}{{ item.ask_type_text.length == (indexask + 1) ? '' : ',' }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row
                v-if="item.ask_help_status == 2 || item.ask_help_status == 3 || item.ask_help_status == 5 || item.ask_help_status == 6">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  受理人员：
                  <span>{{ item.ie_name }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 3 && item.solve_reason">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  备注信息：<span>{{ item.solve_reason }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_help_status == 4">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  操作人员：<span>用户主动撤回</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="(item.ask_help_status == 5||item.ask_help_status == 6) && item.reject_reason">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  拒绝原因：<span>{{ item.reject_reason }}</span>
                </p>
              </a-col>
            </a-row>
            <a-row v-if="item.ask_text">
              <a-col :span="5">
              </a-col>
              <a-col :span="19">
                <p>
                  求助说明：<span>{{ item.ask_text }}</span>
                </p>
              </a-col>
            </a-row>
          </a-timeline-item>
        </a-timeline>
      </a-tab-pane>
      <a-tab-pane tab="回款开票" key="7">
        <template>
          <a-row type="flex" justify="space-between" style="margin-bottom:15px">
            <a-col>
              <a-row type="flex" align="middle" :gutter="15">
                <a-col>
                  <span style="height:25px;border-left:3px solid #35B5FE;"></span>
                </a-col>
                <a-col>
                  <b>收款与开票</b>
                </a-col>
                <a-col>
                  <a-button type="primary" style="margin-left: 600px"
                            @click="communicate_data.visible=true;communicate_data.state=1;communicate_data.title='收费金额'">
                    + 收费金额
                  </a-button>
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-row type="flex" justify="space-between" style="margin-bottom:15px">
            <a-col>
              <a-row type="flex" align="middle" :gutter="15">
                <a-col style="margin-left: 20px">
                  收费金额：{{ this.order.income_amount }}元
                </a-col>
              </a-row>
              <a-row type="flex" align="middle" :gutter="15">
                <a-col style="margin-left: 20px">
                  累计收款：{{ this.order.payment_total }}元
                </a-col>
              </a-row>
              <a-row type="flex" align="middle" :gutter="15">
                <a-col style="margin-left: 20px">
                  累计开票：{{ this.order.invoice_total }}元
                </a-col>
              </a-row>
            </a-col>
          </a-row>
          <a-divider></a-divider>
        </template>
        <a-row type="flex" justify="space-between">
          <a-col>
            <a-row type="flex" align="middle" :gutter="15" style="margin-bottom:25px">
              <a-col>
                <span style="height:25px;border-left:3px solid #35B5FE;"></span>
              </a-col>
              <a-col>
                <b>详细记录</b>
              </a-col>
              <a-col>
                <a-button type="primary" style="margin-left: 450px"
                          @click="communicate_data.visible=true;communicate_data.state=2;communicate_data.title='收费记录';communicate_data.form.amount='';communicate_data.form.collection=undefined">
                  + 添加收费记录
                </a-button>
              </a-col>
              <a-col>
                <a-button type="primary" style="margin-left: 15px"
                          @click="communicate_data.visible=true;communicate_data.state=3;communicate_data.title='开票记录';communicate_data.form.amount='';communicate_data.form.collection=undefined">
                  + 添加开票记录
                </a-button>
              </a-col>
            </a-row>
            <template v-for="(item,index) in communicate_data.group">
              <a-row style="margin-top: 15px;margin-left: 20px" v-if="item.income_type=='payment'">
                <a-col :span="7">
                  <div style="margin-bottom: 15px">回款时间：{{ item.time_at?item.time_at.split(' ')[0]:'' }}</div>
                  <div>回款人：{{ item.user_email }}</div>
                </a-col>
                <a-col :span="7">
                  <div style="margin-bottom: 15px">回款金额：{{ item.amount }}元</div>
                </a-col>
                <a-col :span="7">
                  <div style="margin-bottom: 15px">回款项目：{{
                      item.subject_type == 'first' ? '首款' :
                          item.subject_type == 'last' ? '尾款' : '全款'
                    }}
                  </div>
                </a-col>
              </a-row>
              <a-row style="margin-top: 15px;margin-left: 20px" v-if="item.income_type=='invoice'">
                <a-col :span="7">
                  <div style="margin-bottom: 15px">开票时间：{{ item.time_at?item.time_at.split(' ')[0]:'' }}</div>
                  <div>开票人：{{ item.user_email }}</div>
                </a-col>
                <a-col :span="7">
                  <div style="margin-bottom: 15px">开票金额：{{ item.amount }}元</div>
                </a-col>
                <a-col :span="7">
                  <div style="margin-bottom: 15px">开票项目：{{
                      item.subject_type == 'first' ? '首款' :
                          item.subject_type == 'last' ? '尾款' : '全款'
                    }}
                  </div>
                </a-col>
              </a-row>
              <a-divider></a-divider>
            </template>
          </a-col>
        </a-row>
      </a-tab-pane>
      <!-- <a-tab-pane tab="佣金与回款" key="6">
        <withdraw @addCash="$refs.addCommunicationModal.show(order)"></withdraw>
      </a-tab-pane>-->
    </a-tabs>
    <!-- //modal -->
    <failed-modal ref="failedModal" @ok="getData()"></failed-modal>
    <cancel-interview-modal
        ref="cancelInterviewModal"
        @ok="getData()"
    ></cancel-interview-modal>
    <check-interview-modal
        ref="checkInterviewModal"
        @ok="getData()"
        @cancel="unpassInterview"
    ></check-interview-modal>
    <check-delivery-modal
        ref="checkDeliveryModal"
        @ok="getData()"
        @cancel="unpassInterview"
    ></check-delivery-modal>
    <offer-modal ref="offerModal" @ok="getData()"></offer-modal>
    <add-return-modal ref="addReturnModal" @ok="getData()"></add-return-modal>
    <arrange-interview-modal
        ref="arrangeInterviewModal"
        @ok="getData()"
    ></arrange-interview-modal>
    <comment-modal ref="commentModal" @ok="updateSoft"></comment-modal>
    <add-communication-modal
        ref="addCommunicationModal"
        @ok="updateCommunication"
    ></add-communication-modal>
    <add-attachment-modal
        ref="addAttachmentModal"
        @ok="updateAttachment"
    ></add-attachment-modal>
    <resume-preview-modal ref="preview"></resume-preview-modal>
    <a-modal :maskClosable="false" v-model="communicate_data.visible" :title="communicate_data.title" okText="提交"
             @ok="handleOk" @cancel="resetForm('ruleForm')">
      <a-form-model
          ref="ruleForm"
          style="width: 100%;"
          :model="communicate_data.form"
          :rules="communicate_data.rules"
          :label-col="communicate_data.labelCol"
          :wrapper-col="communicate_data.wrapperCol"
      >
        <template v-if="communicate_data.state==1">
          <a-form-model-item ref="amount" label="金额" prop="amount">
            <a-input
                suffix="元"
                placeholder="请输入具体金额"
                @change="communicate_data.form.amount=communicate_data.form.amount.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                v-model="communicate_data.form.amount"
            />
          </a-form-model-item>
        </template>
        <template v-if="communicate_data.state==2">
          <a-form-model-item label="回款时间" required prop="date">
            <a-date-picker
                v-model="communicate_data.form.date"
                type="date"
                placeholder="请选择日期"
                :format="communicate_data.dateFormat"
                style="width: 100%;"
                @change="onChangedate"
            />
          </a-form-model-item>
          <a-form-model-item label="回款项目" prop="collection">
            <a-select v-model="communicate_data.form.collection" placeholder="请选择项目">
              <a-select-option value="first">
                首款
              </a-select-option>
              <a-select-option value="last">
                尾款
              </a-select-option>
              <a-select-option value="full">
                全款
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="回款金额" prop="amount">
            <a-input
                suffix="元"
                placeholder="请输入具体金额"
                @change="communicate_data.form.amount=communicate_data.form.amount.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                v-model="communicate_data.form.amount"
            />
          </a-form-model-item>
          <a-form-model-item label="回款人" prop="user_name">
            <a-select
                show-search
                :value="communicate_data.form.user_name"
                placeholder="请选择回款人"
                style="width: 100%"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="fetchUser"
                @change="handleChange"
            >
              <a-select-option v-for="d in communicate_data.form.data" :key="d.user_Id">
                {{ d.user_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
        <template v-if="communicate_data.state==3">
          <a-form-model-item label="开票时间" required prop="date">
            <a-date-picker
                v-model="communicate_data.form.date"
                type="date"
                placeholder="请选择日期"
                :format="communicate_data.dateFormat"
                style="width: 100%;"
                @change="onChangedate"
            />
          </a-form-model-item>
          <a-form-model-item label="开票项目" prop="collection">
            <a-select v-model="communicate_data.form.collection" placeholder="请选择项目">
              <a-select-option value="first">
                首款
              </a-select-option>
              <a-select-option value="last">
                尾款
              </a-select-option>
              <a-select-option value="full">
                全款
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item label="开票金额" prop="amount">
            <a-input
                suffix="元"
                placeholder="请输入具体金额"
                @change="communicate_data.form.amount=communicate_data.form.amount.replace(/[^\d{1,}\.\d{1,}|\d{1,}]/g,'')"
                v-model="communicate_data.form.amount"
            />
          </a-form-model-item>
          <a-form-model-item label="归属人" prop="user_name">
            <a-select
                show-search
                v-model="communicate_data.form.user_name"
                placeholder="请选择归属人"
                style="width: 100%"
                :default-active-first-option="false"
                :show-arrow="false"
                :filter-option="false"
                :not-found-content="null"
                @search="fetchUser"
                @change="handleChange"
            >
              <a-select-option v-for="d in communicate_data.form.data" :key="d.user_Id">
                {{ d.user_name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </template>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import moment from "moment";
import Company from "./tabs/company";
import Contact from "./tabs/contact";
import Hunter from "./tabs/hunter";
import Interview from "./tabs/interview";
import Job from "./tabs/job";
import Recommand from "./tabs/recommand";
import Withdraw from "./tabs/withdraw";
import FailedModal from "./failed-modal";
import OrderDetail from "./order-detail";
import CancelInterviewModal from "./cancel-interview-modal";
import CheckInterviewModal from "./check-interview-modal";
import CheckDeliveryModal from "./check-delivery-modal";
import OfferModal from "./offer-modal";
import AddReturnModal from "./add-return-modal";
import ArrangeInterviewModal from "./arrange-interview-modal";
import CommentModal from "./comment-modal";
import AddCommunicationModal from "./add-communication-modal";
import addAttachmentModal from "./add-attachment-modal";
import ResumePreviewModal from "@/components/resume-preview-modal";
import Api from "@/api";
import baseComponentVue from "@/components/base-component.vue";
import {getOrderStatus} from "@/shared/utils/bootstrap";

import debounce from 'lodash/debounce';

export default {
  name: "OrderDetail",
  extends: baseComponentVue,
  props: {
    id: {
      default: -1
    },
    ask_help_id: null,
    hunter_state: null,
    statuses: null,
    communicate: ''
  },
  data() {
    this.lastFetchId = 0;
    this.fetchUser = debounce(this.fetchUser, 800);
    return {
      form: this.$form.createForm(this),
      communicate_sk: false,
      communicate_data: {
        sf: "",
        sk: "",
        kp: "",
        visible: false,
        state: 1,
        title: "",
        labelCol: {span: 4},
        wrapperCol: {span: 14},
        dateFormat: 'YYYY-MM-DD',
        form: {
          amount: '',
          date: undefined,
          datastring: "",
          collection: undefined,
          dataCharge: [],
          user_name: undefined,
          usesr_email: "",
          user_Id: "",
          data: [],
          fetching: false,
        },
        rules: {
          amount: [
            {required: true, message: '请输入具体金额', trigger: 'blur'},
          ],
          date: [{required: true, message: '请选择日期', trigger: 'change'}],
          collection: [{required: true, message: '请选择项目', trigger: 'change'}],
          user_name: [{required: true, message: '请选择', trigger: 'blur'}],
        },
        group: []
      },
      orderStatus: this.$route.params.status,
      viewMoreInfo: false,
      tabs: [],
      job: undefined,
      order: undefined,
      hunter: undefined,
      showAlert: false,
      hunter_help_list: []
    };
  },
  components: {
    Company,
    Contact,
    Hunter,
    Interview,
    Job,
    Recommand,
    Withdraw,
    FailedModal,
    CancelInterviewModal,
    CheckInterviewModal,
    OfferModal,
    AddReturnModal,
    ArrangeInterviewModal,
    CommentModal,
    AddCommunicationModal,
    addAttachmentModal,
    ResumePreviewModal,
    CheckDeliveryModal
  },
  computed: {
    order_id() {
      if (this.id < 0) {
        return this.$route.params.id;
      } else {
        return this.id;
      }
    },
    //step
    current() {
      let status = this.order.status;
      let arr = [
        ["HUNTER_REFUSE", "DELIVER"],
        ["CREATED", "AUDIT_PASSED", "AUDIT_FAILED", "SUBMIT_FAILED"],
        ["SUBMIT_PASSED", "INTERVIEW", "INTERVIEW_FAILED", "CLOSED"],
        ["OFFERED"],
        ["ENTERED", "NOT_ENTERED"],
        ["COMPLETED", "NOT_COMPLETED"],
        ["UNSETTLED", "SETTLED"]
      ];
      return arr.findIndex(item => item.indexOf(status) > -1);
    },
    /**
     * return [-1(process),0(error),1(finish)]
     */
    status() {
      let status = this.order.status;
      let arr = [
        [
          "DELIVER",
          "HUNTER_REFUSE",
          "AUDIT_FAILED",
          "SUBMIT_FAILED",
          "INTERVIEW_FAILED",
          "CLOSED",
          "NOT_ENTERED",
          "NOT_COMPLETED"
        ],
        ["SETTLED"]
      ];
      let i = arr.findIndex(item => item.indexOf(status) > -1);
      return i == -1 ? "error" : i == 0 ? "process" : "finish";
    }
  },
  created() {
    this.getData();
    if (this.hunter_state) {
      Api.hunter.ask_acceptList({
        post_ask_help_id: this.ask_help_id
      }).then(res => {
        this.hunter_help_list = res
      });
    }
    if (this.communicate) {
      this.Get_income()
    }
  },
  mounted() {
    console.log(this.statuses)
  },
  methods: {
    Get_income() {
      Api.hunter.communicate_income({
        post_id: this.id
      }).then(res => {
        if (res.items.length > 0) {
          this.communicate_sk = true;
          this.communicate_data.group = res.items
        }
      });
    },
    handleChange(value) {
      for (let i = 0; i < this.communicate_data.form.data.length; i++) {
        if (this.communicate_data.form.data[i].user_Id == value) {
          this.communicate_data.form.user_Id = value;
          this.communicate_data.form.usesr_email = this.communicate_data.form.data[i].usesr_email;
          this.communicate_data.form.user_name = this.communicate_data.form.data[i].user_name;
        }
      }
    },
    fetchUser(value) {
      console.log('fetching user', value);
      this.lastFetchId += 1;
      const fetchId = this.lastFetchId;
      this.communicate_data.form.data = [];
      this.communicate_data.form.fetching = true;
      Api.post.getSuggest({name: value}).then((body) => {
        if (fetchId !== this.lastFetchId) {
          // for fetch callback order
          return;
        }
        const data = body.map(user => ({
          user_Id: user.uid,
          usesr_email: user.email,
          user_name: user.name,
        }));
        this.communicate_data.form.data = data;
        console.log(this.communicate_data.form.data)
        this.communicate_data.form.fetching = false;
      });
    },
    resetForm(formName) {
      this.communicate_data.form.user_Id = '';
      this.communicate_data.form.usesr_email = '';
      this.communicate_data.form.datastring = '';
      this.$refs[formName].resetFields();
    },
    onChangedate(date, dateString) {
      console.log(date, dateString);
      this.communicate_data.form.datastring = dateString
    },
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          if (this.communicate_data.state == 1) {
            Api.hunter.communicate_setIncomeAmount({
              post_id: this.id,
              income_amount: this.communicate_data.form.amount
            }).then(res => {
              this.$message.success('提交成功');
              this.communicate_data.visible = false;
              this.getData();
            });
          }
          if (this.communicate_data.state == 2) {
            Api.hunter.communicate_create({
              post_id: this.id,
              time_at: this.communicate_data.form.datastring,
              subject_type: this.communicate_data.form.collection,
              amount: this.communicate_data.form.amount,
              user_id: this.communicate_data.form.user_Id,
              user_email: this.communicate_data.form.usesr_email,
              user_name: this.communicate_data.form.user_name,
              income_type: 'payment'
            }).then(res => {
              this.communicate_data.visible = false;
              this.$refs['ruleForm'].resetFields();
              this.$message.success('提交成功');
              this.Get_income()
              this.getData();
            });
          }
          if (this.communicate_data.state == 3) {
            Api.hunter.communicate_create({
              post_id: this.id,
              time_at: this.communicate_data.form.datastring,
              subject_type: this.communicate_data.form.collection,
              amount: this.communicate_data.form.amount,
              user_id: this.communicate_data.form.user_Id,
              user_email: this.communicate_data.form.usesr_email,
              user_name: this.communicate_data.form.user_name,
              income_type: 'invoice'
            }).then(res => {
              this.communicate_data.visible = false;
              this.$refs['ruleForm'].resetFields();
              this.$message.success('提交成功');
              this.Get_income()
              this.getData();
            });
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    async getData() {
      getOrderStatus();
      let {job, post: order, hunter} = await Api.order.getDetail({
        post_id: this.order_id
      });
      this.job = job;
      this.order = order;
      this.$store.commit('setPostId',this.order_id)
      this.$store.commit('setStatus',Number(this.order.status_origin))
      console.log(this.order);
      this.hunter = hunter;
      this.calcTabs(order.timelines);
      if (order.same_resume_name === 1) {
        this.showAlert = true;
      }
    },
    calcTabs(lines) {
      let tabs = [
        {title: "推荐"},
        {title: "面试"},
        {title: "OFFER"},
        {title: "入职"},
        {title: "过保"},
        {title: "结算"}
      ];
      if (this.order.source == "columbus_mini_app") {
        tabs.splice(0, 0, {
          title: "投递"
        })
      }
      lines.forEach(item => {
        item.post_status == "CREATED" &&
        (tabs[0].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "INTERVIEW" &&
        (tabs[1].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "OFFERED" &&
        (tabs[2].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "ENTERED" &&
        (tabs[3].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "COMPLETED" &&
        (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
        item.post_status == "SETTLED" &&
        (tabs[4].time = moment(item.created_at).format("YYYY-MM-DD"));
      });
      this.tabs = [...tabs];
    },
    nextStep(text, record) {
      const h = this.$createElement;
      this.$confirm({
        title: "温馨提示",
        content: h("div", {style: {paddingTop: "20px"}}, [
          h("p", `确定要将简历标记为"${text}"`),
          h("p", "该操作不可逆，请谨慎操作")
        ]),
        onOk: () => {
          //审核通过
          if (record.status === "CREATED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.audit({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //推荐通过
          if (record.status === "AUDIT_PASSED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.submit({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //入职
          if (record.status === "OFFERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.entered({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
          //过保
          if (record.status === "ENTERED") {
            return new Promise(async (resolve, reject) => {
              try {
                await Api.order.completed({post_id: record.id});
                this.getData();
              } catch (e) {
              }
              resolve();
            });
          }
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    //跳转至相似订单
    goDetail() {
      let resolveDRoute = this.$router.resolve({
        path: `/order/detail/${this.order.similar_post_id}`
      });
      window.open(resolveDRoute.href, "_blank");
    },
    stopStep(text, record) {
      let {failedModal} = this.$refs;
      failedModal.title = text;
      failedModal.show(record);
    },
    // 标记面试未通过
    unpassInterview(record) {
      let {failedModal} = this.$refs;
      failedModal.title = "面试未通过";
      failedModal.show(record);
    },
    updateSoft() {
      this.$refs.contact.updateSoft();
    },
    updateCommunication() {
      this.$refs.contact.updateCommunication();
    },
    updateAttachment() {
      this.$refs.contact.updateAttachment();
    },
    handleElimination(data) {
      let str = '';
      let reason_text = data.body ? JSON.parse(data.body).reason_text : '';
      if (reason_text) {
        reason_text.forEach(x => {
          str += x + ' '
        })
      } else {
        str = '无';
      }
      return str;
    }
  }
};
</script>
<style lang="scss" scoped>
.order-info {
  margin: 10px 0 38px;
  border: 1px solid #35b5fe;
  background: rgb(224, 244, 255);
  padding: 15px 20px 2px;
  position: relative;

  .btn {
    cursor: pointer;
    z-index: 10;
    position: absolute;
    right: 10px;
  }

  .reason {
    color: rgb(238, 88, 88);
    padding-left: 30px;
  }
}
</style>
